declare global {
    interface Window {
        Pinia: any;
    }
}

import { createApp } from 'vue'

import Locations from '~/vue/apps/Locations.vue'

// Main app
const locations = async () => {
    const locations = createApp(Locations)

    locations.use(window.Pinia)

    return locations.mount('#vue-locations')
}

// Execute async function
locations().then(() => {
    console.log()
})

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR active')
    })
}